<template>
    <div class="root-dialog-container">
        <div class="modal">
            <div class="modal-content large">
                <div class="content-container">
                    <div class="header">
                        <div class="title">Select Date/Time Format</div>
                    </div>
                    <div class="content">
                        <DateFormatPicker v-model="options.customModel" />
                    </div>
                    <div class="footer">
                        <div class="buttons">
                            <button id="modal-button-secondary" @click="buttonOKClick">OK</button>
                            <button id="modal-button-primary" @click="buttonCancelClick">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import DateFormatPicker from './DateFormatPicker.vue';

export default {
    components: {
        DateFormatPicker
    },
    data() {
        return {
        }
    },
    props: ['options'],
    methods: {        
        buttonOKClick: function() { this.options.button1Callback(); },
        buttonCancelClick: function() { this.options.button2Callback(); },
    },

    mounted() {
    }
}
</script>

